import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyDyoOf3-IHRbCwHo0Km_2fOaEPscQ7gmUg",
  authDomain: "alphamarsfront.firebaseapp.com",
  projectId: "alphamarsfront",
  storageBucket: "alphamarsfront.appspot.com",
  messagingSenderId: "71540616988",
  appId: "1:71540616988:web:128eee4fda4dfc9f9094d9",
  measurementId: "G-88Q84GVZ59"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

